import { StatiquePageService } from './../Service/statique-page.service';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Global } from '../Service/global.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {


  constructor(public global: Global,
    private service: StatiquePageService,
    private aroute: ActivatedRoute,
    private router: Router) { }

  isArab = false;
  section='';
  Title='';
  ngOnInit(): void {


    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
        lg.code == "ar" ? this.isArab = true : this.isArab = false;
          const url = this.router.url;
          //console.log("breadcrumb url",url);
          this.service.getMenu(lg.url).subscribe(m => {
            //console.log("breadcrumb m",m);
            let a = m['value'].filter(ele => {
              return ele['ApplicationUrl']? url.toLowerCase().indexOf(ele['ApplicationUrl'].toLowerCase()) != -1: false
            })
           // console.log("breadcrumb",a);
            this.section = a[0]["Section"];
            this.Title = a[0]["Title"];
          })
      })
  }

}
